import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  PiuApplicationsResponse,
  PiuApplicationsVars,
  PiuApplyResponse,
  PiuApplyVars,
  PiuOverviewResponse,
  PiuOverviewVars,
  PiuSaveResponse,
  PiuSaveVars,
  ProductInfoUsageApiPath
} from '@/common/api/params/productInfoUsage'

/** 反映の進行中だけポーリングする（常時ポーリングは無駄な負荷になる） */
const POLL_MS = 5000

/** 定義・現在値・未反映・履歴をまとめて取得する。反映中は自動で追従する */
export const useProductInfoUsageApi = (vars: PiuOverviewVars | undefined) => {
  return useSWR<PiuOverviewResponse, Response, [string, PiuOverviewVars] | undefined>(
    vars ? [ProductInfoUsageApiPath.OVERVIEW, vars] : undefined,
    // 既定の fetcher を使う。`undefined` では型が通らないので null を渡す
    null,
    // 実行中の行があるあいだだけ間隔を開ける。状態から決めるので、
    // 呼び出し側で開始・停止を管理しなくてよい
    { refreshInterval: (latest) => (latest?.running_application ? POLL_MS : 0) }
  )
}

/** 反映履歴。進行中はポーリングで追従する */
export const useProductInfoUsageApplicationsApi = (vars: PiuApplicationsVars | undefined) => {
  return useSWR<PiuApplicationsResponse, Response, [string, PiuApplicationsVars] | undefined>(
    vars ? [ProductInfoUsageApiPath.APPLICATIONS, vars] : undefined,
    null,
    {
      refreshInterval: (latest) =>
        (latest ?? []).some((a) => a.status === 'running') ? POLL_MS : 0
    }
  )
}

/** 保存。索引は変わらない（反映は useApplyProductInfoUsageApi） */
export const useSaveProductInfoUsageApi = (options?: MutationOptions<PiuSaveResponse>) => {
  return useCallMutation<PiuSaveResponse, PiuSaveVars>(
    ProductInfoUsageApiPath.SAVE,
    options,
    apiPutFetcher
  )
}

/** 反映。索引を作り直す（バックグラウンド実行） */
export const useApplyProductInfoUsageApi = (options?: MutationOptions<PiuApplyResponse>) => {
  return useCallMutation<PiuApplyResponse, PiuApplyVars>(ProductInfoUsageApiPath.APPLY, options)
}
